export default {"src":"/_next/static/media/rosemary.316b1cac.svg","height":29,"width":84,"blurWidth":0,"blurHeight":0};